/* 30/09/26 (Mathéo) : au survol d'une carte, le thème affiche la 2e photo, mais elle est en chargement différé
   -> fond vide le temps du téléchargement. Sur ordinateur UNIQUEMENT (souris), on précharge la photo de survol
   des cartes proches de l'écran. Mobile : rien n'est chargé en plus (le script s'arrête tout de suite). */
(function () {
  if (!window.matchMedia || !matchMedia('(hover: hover) and (pointer: fine)').matches || !('IntersectionObserver' in window)) return;
  function warm(g) {
    var imgs = g.querySelectorAll('img');
    for (var i = 0; i < imgs.length && i < 3; i++) if (imgs[i].loading === 'lazy') imgs[i].loading = 'eager';
  }
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { warm(e.target); io.unobserve(e.target); } });
  }, { rootMargin: '300px 0px' });
  function scan() { document.querySelectorAll('.card-gallery:not([data-casa-warm])').forEach(function (g) { g.setAttribute('data-casa-warm', '1'); io.observe(g); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  // cartes ajoutées par le filtre / la pagination
  var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 300); }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
})();
